<script lang="ts">
	import { handleStoreError } from '../../stores/GeneralStore';
	import Icon from '../Icon.svelte';

	interface Props {
		checked: boolean;
		disabled?: boolean;
		//Should the bool be inverted?
		inverted?: boolean;
		propertyName: string;
		callFunction?: ((object: any) => Promise<any>) | null;
		iconNameLeft: string;
		iconNameRight: string;
		title?: string;
		onCheckChanged?: (checked: boolean) => void;
	}

	let {
		checked = $bindable(),
		disabled = false,
		inverted = false,
		propertyName,
		callFunction = null,
		iconNameLeft,
		iconNameRight,
		title = '',
		onCheckChanged = undefined
	}: Props = $props();

	async function handleCheckChanged() {
		if (callFunction) {
			//Invert it first
			if (inverted) {
				checked = !checked;
			}

			//Set the new state
			checked = !checked;

			try {
				const dynamicObject: any = {};
				dynamicObject[propertyName] = checked;

				await callFunction(dynamicObject);
			} catch (error) {
				//Check if we have an error type
				handleStoreError('general.patch_failed', error);

				//Invert it again
				checked = !checked;
			}
		} else {
			checked = !checked;
			onCheckChanged?.(checked);
		}
	}
</script>

<button
	{disabled}
	class="bg-white dark:bg-dark-200 rounded-full flex border-2 gap-2 border-gray dark:border-dark-200"
	{title}
	onclick={handleCheckChanged}
>
	<div
		class="p-2 rounded-full {checked
			? ''
			: 'fill-white bg-secondary-200 dark:bg-secondary-500 dark:fill-dark-200'}"
		class:bg-disabled={disabled}
	>
		<Icon name={iconNameLeft}></Icon>
	</div>

	<div
		class="p-2 rounded-full {checked
			? 'fill-white bg-secondary-200 dark:bg-secondary-500 dark:fill-dark-200'
			: ''}"
		class:bg-disabled={disabled}
	>
		<Icon name={iconNameRight}></Icon>
	</div>
</button>
